export const SET_WEBINAR_ATTENDEE = "SET_WEBINAR_ATTENDEE";
